import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-setting',
  templateUrl: './nav-setting.component.html',
  styleUrls: ['./nav-setting.component.scss']
})
export class NavSettingComponent implements OnInit {

  @Input() activeLink: string;

  constructor(public authService: AuthService, public router: Router) { }

  ngOnInit() {
  }

}
